import { useUiText } from "../../locale/UiLocale";
import { Icon } from "../../icons";
import { pageList } from "./paging";

interface PagerProps {
  currentPage: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}

/** Previous / page numbers / next. */
export function Pager({ currentPage, pageCount, onPageChange }: PagerProps): React.JSX.Element {
  const t = useUiText();
  return (
    <nav className="nb-pager" aria-label={t("Pagination")}>
      <button
        type="button"
        className="nb-page"
        disabled={currentPage === 1}
        aria-label={t("Previous page")}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <Icon name="chevronLeft" />
      </button>
      {pageList(currentPage, pageCount).map((page, i) =>
        page === "gap" ? (
          <span key={`gap-${i}`} className="nb-page-gap" aria-hidden="true">
            …
          </span>
        ) : (
          <button
            key={page}
            type="button"
            className="nb-page nb-page-num"
            aria-current={page === currentPage ? "page" : undefined}
            aria-label={`${t("Page")} ${page}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ),
      )}
      <button
        type="button"
        className="nb-page"
        disabled={currentPage === pageCount}
        aria-label={t("Next page")}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <Icon name="chevronRight" />
      </button>
    </nav>
  );
}
